/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import classNames from "classnames";
import { EvidencePart } from "@interfaces/Interfaces";
import { shouldInvertBannerTextColor } from "./helpers/evidencePartUtils";

type Props = {
  definition: EvidencePart;
  isPDF: boolean;
  isDisplay: boolean;
};

const Banner: React.FC<Props> = (props) => {
  const bannerColourVariants: any = {
    Red: "!bg-red-banner",
    Yellow: "!bg-yellow-banner",
    Grey: "!bg-grey-20",
    Blue: "!bg-blue-banner",
    Green: "!bg-green-banner",
  };

  if (props.isDisplay || props.isPDF) {
    return null;
  }

  const bannerColor = props.definition["Banner colour"] ?? props.definition["Banner color"] ?? "Grey";

  return (
    <div className={`reflectionContentCard ${bannerColourVariants[bannerColor]}`}>
      <div
        className={classNames("reflectionContentCardTitle !mb-0 whitespace-pre-wrap", {
          "!text-white": shouldInvertBannerTextColor(bannerColor),
        })}
      >
        {props.definition["Display Title"]}
      </div>
      {props.definition["Display Subtitle"] && (
        <div
          className={classNames("reflectionContentCardTitle !mb-0 mt-1 whitespace-pre-wrap !font-acc-normal", {
            "!text-white": shouldInvertBannerTextColor(bannerColor),
          })}
        >
          {props.definition["Display Subtitle"]}
        </div>
      )}
    </div>
  );
};

export default Banner;
